<style>
  .custom-loader {
    animation: loader 1s infinite;
    position: absolute;
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>

<template>
  <div
    v-if="this.$store.state.activeTemplate && this.$store.state.activeTemplate.isGenerating === 'done'"
    style="display: flex; justify-content: flex-end; width: 100%; position: relative;"
  >
    <v-btn
      v-if="!$store.state.isEditingToolsVisible"
      @click="startEditing"
      color="primary"
    >{{ translate('ui_start_editing') }}
    </v-btn>

    <v-spacer v-if="!$store.state.isEditingToolsVisible"/>

    <div style="display: flex; justify-content: flex-end; gap: 20px;">
      <v-btn v-if="$store.state.user.settings.plan === 0" @click="loadScreenshots" style="position: fixed; top: 100px; right: 20px;" x-small>
        load screens
      </v-btn>

      <v-btn
        v-if="this.$store.state.activeTemplate.data"
        @click="(event) => downloadModel(event, false)"
        :disabled="isBuildButtonDisabled"
        class="ma-2"
        color="success"
        :small="$store.state.mode !== 'static'"
        style="margin: 0 !important; padding: 0 8px;"
      >
        <template v-slot>
          <span
            style="align-items: center; display: flex;"
            :style="$store.state.building ? { opacity: 0 } : { opacity: 1 }"
          >
            <v-icon style="font-size: 16px;">mdi-download</v-icon>
            <div class="d-none d-sm-flex" style="margin-left: 5px; text-align: left; flex-direction: column;">
              <div
                :style="$store.state.mode === 'static' ? 'font-size: 12px' : 'font-size: 10px'"
                style="text-indent: initial; font-size: 10px;"
              >
                {{ translate('ui_download_model_btn_label') }}
              </div>
            </div>
          </span>

          <span
            class="custom-loader"
            :style="$store.state.building ? { opacity: 1 } : { opacity: 0 }"
          >
            <v-icon style="font-size: 16px;">mdi-download</v-icon>
          </span>

        </template>
      </v-btn>

      <div style="display: flex; flex-direction: column; align-items: center;">
        <v-btn
          v-if="!downloadOptions || downloadOptions.isGoogleSheetsEnabled"
          @click="(event) => downloadModel(event, true)"
          :disabled="isBuildGSButtonDisabled"
          class="ma-2"
          color="success"
          :small="$store.state.mode !== 'static'"
          style="margin: 0 !important; padding: 0 8px;"
        >
          <template v-slot>
            <span
              style="align-items: center; display: flex;"
              :style="$store.state.buildingGS ? { opacity: 0 } : { opacity: 1 }"
            >
              <v-icon light style="font-size: 20px;">mdi-google-spreadsheet</v-icon>
              <div class="d-none d-sm-flex" style="margin-left: 5px; text-align: left; flex-direction: column;">
                <div
                  :style="$store.state.mode === 'static' ? 'font-size: 12px' : 'font-size: 10px'"
                  style="text-indent: initial; font-size: 10px;"
                >
                  {{ translate('ui_generate_gs_btn_label') }}
                </div>
              </div>
            </span>

            <span
              :style="$store.state.buildingGS ? { opacity: 1 } : { opacity: 0 }"
              style="position: absolute;"
            >
              <v-icon light class="custom-loader" style="font-size: 18px;">mdi-google-spreadsheet</v-icon>
              <span class="d-none d-md-inline" v-if="$store.state.buildingGS" style="text-transform: none; margin-left: 4px; letter-spacing: normal;">
                {{ translate('ui_generate_gs_btn_please_wait') }}
              </span>
            </span>
          </template>
        </v-btn>
        <!--
        <div
          class="d-none d-sm-flex"
          style="font-size: 11px; margin-top: 3px; color: #555;"
        >
          <span v-if="!$store.state.buildingGS">{{ translate('ui_generate_gs_btn_hint') }}</span>
          <span v-if="$store.state.buildingGS">{{ translate('ui_generate_gs_btn_please_wait') }}</span>
        </div>
        -->
      </div>
    </div>

    <div v-if="!hasSalesResources" style="position: absolute; bottom: -40px; left: 50%; transform: translateX(-50%); padding: 2px 5px; width: 100%; text-align: center;">
      <v-alert
        dense
        style="padding: 1px 7px; font-size: 11px; display: inline-block; background-color: #fb8c00; color: #fff;"
      >
        <v-icon style="color: #fff; font-size: 14px;">mdi-alert</v-icon>
        {{ translate('ui_add_revenues') }}
      </v-alert>

    </div>
  </div>
</template>

<script>
import Mixin from '@/mixins/mixin';

export default {
  name: 'TemplateToolbar.vue',
  mixins: [Mixin],
  props: ['downloadOptions'],
  methods: {
    startEditing() {
      this.$store.state.isEditingToolsVisible = true;
      setTimeout(() => {
        window.scroll({ top: 0, behavior: 'smooth' });
      }, 0);
    },
    loadScreenshots() {
      // get screenshots
      this.$store.dispatch('getGoogleSheetsScreenshots');
    },
    downloadModel(event, isGoogleSheets) {
      event.stopPropagation();
      this.$store.dispatch('downloadModel', isGoogleSheets);
    },
  },
  computed: {
    hasSalesResources() {
      return this.$store.state.activeTemplate.data.divisions[0].sectionResources.some((sr) => sr.coreResource.rel === 'service');
    },
    isBuildButtonDisabled() {
      const isBuilding = this.$store.state.building;
      return isBuilding || !this.hasSalesResources;
    },
    isBuildGSButtonDisabled() {
      const isBuildingGS = this.$store.state.buildingGS;
      return isBuildingGS || !this.hasSalesResources;
    },
  },
};
</script>
